<template>
<div class="ptb-20 border-t-b">
	<BreadCrumbHeader title="About Me"  lastCrumb="About" />
	<div class="about-us-area pt-90">
		<div class="container">
			<div id="about-title" class="area-title text-left">
				<h2>HELLO, I'M Fredericka</h2>
			</div>			
			<div class="row">
				<!-- ABOUT TEXT -->
				<div class="col-md-6">
					<div class="about-text mt-50">
						<p>I'm a UX designer with a passion for driving business growth through innovation and creativity. 
 Most of my expertise comes from working on enterprise products, design systems, mobile applications and immersive experiences.
 <br>My key strengths include user experience design, visual design and prototyping.   
 <br>I’ve worked internationally, in-house, and remotely on projects  for a variety of organizations including startups, small companies and big corporations.
</p><p>I look forward to creating world-class, useful, and beautiful products that help people and make a difference.

</p>
					
						<div class="signature mt-20">
							<img src="/images/signature.svg" alt="">
						</div>
					</div>
				</div>
				<!-- /ABOUT TEXT -->
				<!-- PHOTO -->
				<div class="col-md-6">
					<div class="about-img hidden-sm hidden-xs">
						<img src="/images/myphoto2.png" alt="">
					</div>
				</div>
				<!-- /PHOTO -->
			</div>
		</div>
	</div>
</div>
</template>

<script>
import BreadCrumbHeader from '@/components/elements/BreadCrumbHeader.vue';

export default {
  components: {
    BreadCrumbHeader,
  }
}
</script>

<style scoped>
#about-title {
  margin: auto;
  width: 100%;
}
</style>

